// extracted by css-extract-rspack-plugin
export default {"root":"root-gBFz6q","scroller":"scroller-LOQEyG","header":"header-vitdwY"};